import { Component, Output, EventEmitter } from "@angular/core";
import {
  faChartBar,
  faChartLineUp,
  faChartScatter,
} from "@fortawesome/pro-light-svg-icons";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-create-new-charts-base",
  templateUrl: "./create-new-charts-base.component.html",
  styleUrls: ["./create-new-charts-base.component.scss"],
})
export class CreateNewChartsBaseComponent {
  faChartBar = faChartBar;
  faChartLineUp = faChartLineUp;
  faChartScatter = faChartScatter;
  assets = environment.assetUrl;
  @Output() setContext: EventEmitter<string> = new EventEmitter();

  onClick(type: string) {
    switch (type) {
      case "Comparison":
        this.setContext.emit("Comparison");
        break;
      case "Timeseries":
        this.setContext.emit("Timeseries");
        break;
      case "scatter":
        this.setContext.emit("scatter");
        break;
      case "line":
        this.setContext.emit("line");
        break;
      default:
        this.setContext.emit("Timeseries");
        break;
    }
  }
}
